import { Component, Input } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, ModalService } from '../../../../tms-shared';
import { AddressDetails, SupplierAddressEdit } from '../../../models';
import { AddressService, SupplierAddressService } from '../../../services';

@Component({
  selector: 'app-supplier-address-create-modal',
  templateUrl: './supplier-address-create-modal.component.html',
  styleUrl: './supplier-address-create-modal.component.scss',
})
export class SupplierAddressCreateModalComponent extends BaseComponent {
  @Input() id: string; // supplierId

  constructor(
    public addressService: AddressService,
    private supplierAddressService: SupplierAddressService,
    private modalService: ModalService,
  ) {
    super();
  }

  saved(model: AddressDetails) {
    const supplierAddress = { addressId: model.id, supplierId: this.id } as SupplierAddressEdit;
    this.supplierAddressService
      .save(supplierAddress)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.modalService.close(supplierAddress));
  }
}
